module.exports = __webpack_public_path__ + "static/media/freedom_90day_challenge.4b71aa19.jpg";